import { cn } from "@/lib/utils";
import { LucideMonitorCheck, LucideBarChart, LucideNewspaper, LucideLineChart, LucideMessageSquareText, LucideRadar } from 'lucide-react'

export function FeaturesSectionWithHoverEffects() {
  const features = [
    {
      icon: <LucideMonitorCheck className="h-10 w-10 text-[#8A6FE8]" />,
      title: 'Real-Time Monitoring',
      description: 'Track mentions of your brand across news sites, blogs, and social media platforms in real-time'
    },
    {
      icon: <LucideBarChart className="h-10 w-10 text-[#8A6FE8]" />,
      title: 'Sentiment Analysis',
      description: 'Understand the tone and emotional context of every mention with our advanced AI sentiment analysis'
    },
    {
      icon: <LucideNewspaper className="h-10 w-10 text-[#8A6FE8]" />,
      title: 'News Clipping',
      description: 'Automatically collect and organize articles and posts that mention your brand or keywords'
    },
    {
      icon: <LucideLineChart className="h-10 w-10 text-[#8A6FE8]" />,
      title: 'Trend Detection',
      description: 'Identify emerging patterns and topics related to your brand before they go mainstream'
    },
    {
      icon: <LucideMessageSquareText className="h-10 w-10 text-[#8A6FE8]" />,
      title: 'Competitor Analysis',
      description: "Compare your brand's media presence and sentiment against competitors"
    },
    {
      icon: <LucideRadar className="h-10 w-10 text-[#8A6FE8]" />,
      title: 'Customizable Alerts',
      description: 'Get instant notifications for high-priority mentions or sentiment changes'
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 relative z-10 max-w-7xl mx-auto">
      {features.map((feature, index) => (
        <Feature key={feature.title} {...feature} index={index} />
      ))}
    </div>
  );
}

const Feature = ({
  title,
  description,
  icon,
  index,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  index: number;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col py-8 lg:py-10 px-4 md:px-6 relative group/feature rounded-lg border border-transparent hover:border-gray-800 transition-all duration-300"
      )}
    >
      <div className="opacity-0 group-hover/feature:opacity-100 transition duration-300 absolute inset-0 h-full w-full bg-gradient-to-tr from-[#8A6FE8]/10 via-transparent to-transparent rounded-lg pointer-events-none" />
      
      <div className="mb-5 relative z-10 px-4 md:px-6">
        <div className="p-3 bg-[#100D1C] rounded-lg inline-flex items-center justify-center">
          {icon}
        </div>
      </div>
      
      <div className="text-xl font-bold mb-3 relative z-10 px-4 md:px-6">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-10 w-1 rounded-tr-full rounded-br-full bg-gray-700 group-hover/feature:bg-[#8A6FE8] transition-all duration-300 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-300 inline-block text-white">
          {title}
        </span>
      </div>
      
      <p className="text-sm text-gray-300 max-w-xs relative z-10 px-4 md:px-6">
        {description}
      </p>
    </div>
  );
};
